const StatCard = ({ title, value, hint, icon, color = "#7DF9FF" }) => (
    <div className="stat-card">
        <div className="stat-card-icon" style={{
            color: color,
            background: `${color}15`,
        }}>
            {icon}
        </div>
        <div className="stat-card-content">
            <h3>{title}</h3>
            <p>{value}</p>
            <span className="card-hint">{hint}</span>
        </div>
    </div>
);

export default StatCard;
